
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'
import JsonDebug from '../ui-elements/JsonDebug'
import DisplayRecursiveFolder from './DisplayRecursiveFolder'
import MoveToFolder from './MoveToFolder'
import Spinner from '../ui-elements/Spinner'
import AddNewFolder from './AddNewFolder'
import Card from '../ui-elements/Card'
import { subscribe } from '../utils/pubsub'
import AddButton from '../formfields/AddButton'

type Props = {
}


function FolderStructure({
}: Props) {

  const {
    tableData,
    setShowModal,
    sendMessageToWebsocket
  } = useContext(GlobalContext)



  const [itemToMove, setItemToMove] = useState<null | ObjectStringKeyAnyValue>(null)
  const [showAddNewFolder, setShowAddNewFolder] = useState(false)
  const [processedFolderData, setProcessedFolderData] = useState<null | ObjectStringKeyAnyValue>(null)
  const [orgsWithNoParentFolder, setOrgsWithNoParentFolder] = useState<null | ObjectStringKeyAnyValue>(null)

  useEffect(() => {
    if (tableData && tableData.Organisations && tableData.Folders) {
      const newProcessedFolderData = processFolderData('')
      setProcessedFolderData(newProcessedFolderData)
      const newOrgsWithNoParentFolder = findOrganisationsWithNoParentFolder()
      setOrgsWithNoParentFolder(newOrgsWithNoParentFolder)
    }
  }, [tableData])



  const findOrganisationsWithNoParentFolder = () => {
    //add orgs with no parent folders
    const organisations = tableData.Organisations
    const folders = tableData.Folders
    // console.log('finding orgs with no parents')
    // console.log(organisations)
    const newOrgsWithNoParentFolder: ObjectStringKeyAnyValue = {}
    for (const organisationId in organisations) {
      const thisOrganisation = organisations[organisationId]
      if (
        !thisOrganisation.ParentFolderId 
        || thisOrganisation.ParentFolderId === ''
        || !Object.keys(folders).includes(thisOrganisation.ParentFolderId)
      ) {
        //console.log(`found org with no parent: ${thisOrganisation.OrganisationName}`)
        newOrgsWithNoParentFolder[organisationId] = {
          'DisplayName': thisOrganisation.OrganisationName,
          'ParentFolderId': ''
        }
      }
    }
    return newOrgsWithNoParentFolder
  }

  const processFolderData = (
    parentFolderId: string
  ) => {

    const organisations = tableData.Organisations
    const folders = tableData.Folders

    const newProcessedFolderData: ObjectStringKeyAnyValue = {}

    // loop through folders
    for (const folderId in folders) {
      const thisFolder = folders[folderId]
      // if parent folder id is blank AND its a root folder
      // or if parent id matches 
      if (
        (parentFolderId === '' && !thisFolder.ParentFolderId) ||
        (parentFolderId === thisFolder.ParentFolderId)
      ) {
        newProcessedFolderData[folderId] = {
          'DisplayName': thisFolder.DisplayName,
          'ParentFolderId': thisFolder.ParentFolderId,
          'Subfolders': processFolderData(folderId),
          'Organisations': {}
        }
        for (const organisationId in organisations) {
          const thisOrganisation = organisations[organisationId]
          if (
            thisOrganisation.ParentFolderId 
            && thisOrganisation.ParentFolderId === folderId
            && Object.keys(folders).includes(thisOrganisation.ParentFolderId)
          ) {
            newProcessedFolderData[folderId]['Organisations'][organisationId] = {
              'DisplayName': thisOrganisation.OrganisationName,
              'ParentFolderId': thisOrganisation.ParentFolderId
            }
          }
        }
      }
    }


    return newProcessedFolderData
  }

  const moveItemToNewParentFolder = (itemToMove: ObjectStringKeyAnyValue, selectedFolderId: string) => {
    const itemId = itemToMove.thisItemId
    const itemType = itemToMove.type
    setItemToMove(null)
    const payload: ObjectStringKeyAnyValue = {
      action: "portal",
      subAction: "moveItem",
      itemId: itemId,
      parentFolderId: selectedFolderId
    }

    if (itemType === 'organisation') {
      setShowModal({ "spinner": "Moving organisation..." })
      payload['subAction'] = 'moveOrganisation'
      payload['organisationId'] = itemId
    }
    else {
      setShowModal({ "spinner": "Moving folder..." })
      payload['subAction'] = 'moveFolder'
      payload['folderId'] = itemId
    }
    const unsubscribe = subscribe("itemMoved", data => {
      if (data.Id === itemId) {
        setShowModal(null)
      }
      unsubscribe()
    })
    sendMessageToWebsocket(JSON.stringify(payload))
  }





  if (!processedFolderData) {
    return <Spinner>Loading...</Spinner>
  }

  return <div className={`w-full flex flex-col items-center justify-center gap-4`}>

    {itemToMove && <MoveToFolder
      folders={processedFolderData}
      setItemToMove={setItemToMove}
      itemToMove={itemToMove}
      moveItemToNewParentFolder={moveItemToNewParentFolder}

    />}

    {showAddNewFolder && <AddNewFolder
      folders={processedFolderData}
      setShowAddNewFolder={setShowAddNewFolder}

    />
    }

    <div className={`w-full flex flex-col items-start justify-between gap-4`}>
      <h3 className={`text-2xl font-brandblue font-righteous`}>Organisation structure</h3>

      <AddButton
        onClick={() => setShowAddNewFolder(true)}
        text='Add new folder'
        fullwidth={true}
      />
    </div>

    <div className={`w-full flex flex-col gap-1`}>
      <DisplayRecursiveFolder
        setItemToMove={setItemToMove}
        folders={processedFolderData}
        showIndentation={false}
      />

      {orgsWithNoParentFolder && <DisplayRecursiveFolder
        setItemToMove={setItemToMove}
        folders={orgsWithNoParentFolder}
        type={'organisation'}
        showIndentation={false}
      />}
    </div>

    {/* <JsonDebug jsonobject={processedFolderData} /> */}
    {/* <JsonDebug jsonobject={tableData.Folders} /> */}
    {/* <JsonDebug jsonobject={tableData.Organisations} /> */}


  </div>
}

export default FolderStructure